import { useCallback, useState } from 'react';

import { CancelTarget } from '../types';

import { useCancelReferralRequest } from './use-cancel-referral-request';

function nextTarget(latest: CancelTarget | null, attempted: CancelTarget, cancelled: boolean): CancelTarget | null {
  const dialogChanged = latest !== attempted;
  if (dialogChanged) return latest;

  return cancelled ? null : { ...attempted, failed: true };
}

const useCancelReferralRequestDialog = (refresh: () => void) => {
  const { cancelling, cancelReferralRequest } = useCancelReferralRequest();
  const [target, setTarget] = useState<CancelTarget | null>(null);

  const openDialog = useCallback((referralRequestId: string) => setTarget({ failed: false, referralRequestId }), []);
  const closeDialog = useCallback(() => setTarget(null), []);

  const confirmCancel = useCallback(
    async (attempted: CancelTarget) => {
      const cancelled = await cancelReferralRequest(attempted.referralRequestId);

      refresh();
      setTarget((latest) => nextTarget(latest, attempted, cancelled));
    },
    [cancelReferralRequest, refresh]
  );

  return { cancelling, closeDialog, confirmCancel, openDialog, target };
};

export { useCancelReferralRequestDialog };
